module.exports = __webpack_public_path__ + "img/brand-cases23.67cbe8f8.png";